import { usePage, useWebsiteSettings } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { typographySelectorMap } from 'src/publisher/store/website-settings/website-settings-selector'
import { DEFAULT_LINE_HEIGHT } from 'src/shared/constants/default-line-height'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'
import { useCalculateFontSize } from './use-calculate-font-size'

export const useCalculateLineHeight = ({
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  typographyType = WebsiteSettingsTypographyTypeEnum.Paragraph,
}: {
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  typographyType?: WebsiteSettingsTypographyTypeEnum
}) => {
  const typographySelector = typographySelectorMap[typographyType]

  const {
    lineHeight: websiteGlobalLineHeight,
    mobileLineHeight: websiteGlobalMobileLineHeight,
  } = useWebsiteSettings(typographySelector) || {}

  const pageGlobalLineHeight = usePage(pageSelectors.getGlobalTextLineHeight)
  const pageGlobalMobileLineHeight = usePage(
    pageSelectors.getGlobalMobileTextLineHeight,
  )
  const globalLineHeight =
    pageGlobalLineHeight || (websiteGlobalLineHeight as number)
  const globalMobileLineHeight =
    pageGlobalMobileLineHeight || (websiteGlobalMobileLineHeight as number)

  const { calculatedFontSize } = useCalculateFontSize({
    fontSize,
    mobileFontSize,
    typographyType: typographyType,
  })

  const computedLineHeight = Math.round(
    DEFAULT_LINE_HEIGHT * (calculatedFontSize.desktop as number),
  )

  const computedMobileLineHeight = Math.round(
    DEFAULT_LINE_HEIGHT * (calculatedFontSize.mobile as number),
  )

  return {
    calculatedLineHeight: getCalculatedProperty({
      desktopProperty: lineHeight,
      mobileProperty: mobileLineHeight,
      globalDesktopProperty: globalLineHeight || computedLineHeight,
      globalMobileProperty: globalMobileLineHeight || computedMobileLineHeight,
    }),
    globalLineHeight,
    globalMobileLineHeight,
  }
}
